import { Strings } from "@constant";
import { EarnPointsPage } from "@containers";
import { useEffect } from "react";

export const EarnPoints = () => {
  useEffect(() => {
    document.title = Strings.pageTitle("Earn Points");
  });

  return (
    <>
      <EarnPointsPage />
    </>
  );
};
